import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "shortName"]

  connect() {
    this.markShortNameEdited()
  }

  titleCase(str) {
    return str.replace(/\w\S*/g, (txt) =>
      txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    )
  }

  formatName() {
    this.nameTarget.value = this.titleCase(this.nameTarget.value)
  }

  formatShortName() {
    this.shortNameTarget.value = this.shortNameTarget.value.toUpperCase()
  }

  generateShortName(name) {
    const match = name.match(/^(\d+),?\s+(.+)/)

    if (match) {
      const number = match[1]
      const initials = match[2].split(/\s+/).map(w => w[0].toUpperCase()).join("")
      return `${number}${initials}`
    }
    else {
      // doesn't match with number, just take initials of all words
      const initials = name.split(/\s+/).map(w => w[0].toUpperCase()).join("")
      return `${initials}`
    }

    return undefined
  }

  updateShortName() {
    if (this.shortNameWasEdited) return
    const name = this.nameTarget.value.trim()
    if (name === "") return

    const shortName = this.generateShortName(name)
    if (shortName) {
      this.shortNameTarget.value = shortName
    }
  }

  markShortNameEdited() {
    this.shortNameWasEdited = (this.shortNameTarget.value.trim() !== "")
  }

  handleEnterOnName(event) {
    this.formatName()
    this.updateShortName()
  }
}
